export const PRECOMPUTED_TOOLS = ['VHS', 'NorbergOlsson'] as const;
Object.freeze(PRECOMPUTED_TOOLS);
